import { ReactNode } from "react";

export default function Menu({
  itemGroups,
  className = "",
}: {
  itemGroups: MenuItem[][];
  className?: string;
}) {
  return (
    <div className={`grid grid-cols-1 divide-y text-sm bg-white ${className}`}>
      {itemGroups.map((group, i) => (
        <div key={i}>
          {group.map(({ label, click = () => {}, className = "" }, j) => (
            <div
              key={j}
              className={`rounded-sm m-1 px-4 py-2 whitespace-nowrap hover:bg-slate-100 cursor-pointer select-none ${className}`}
              onClick={click}
            >
              {label}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export interface MenuItem {
  label: ReactNode;
  className?: string;
  click?: () => void;
}
